export default __webpack_public_path__ + "static/media/step2bLightMode.3e841958.svg";